import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import { TourProvider } from "@/components/tour/TourProvider";
import { ConfigProvider } from "@/contexts/ConfigContext";
import { UIProvider } from "@/contexts/UIContext";
import { InstallPrompt } from "@/components/shared/InstallPrompt";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ConfigProvider>
        <UIProvider>
          <TourProvider>
            <App />
            <InstallPrompt />
          </TourProvider>
        </UIProvider>
      </ConfigProvider>
    </BrowserRouter>
  </React.StrictMode>,
);

// PWA: registra el service worker (app shell + push). Idempotente con AdminPushToggle.
if ("serviceWorker" in navigator && window.location.protocol === "https:") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((e) => console.warn("SW register failed:", e));
  });
}
